(function () {
  'use strict';

  var SELECTOR = '[data-aq-commercial]';
  var TRACKING_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

  function getFocusableHeaderOffset(root) {
    var header = root.querySelector('[data-aq-header]');
    return header ? header.offsetHeight + 12 : 0;
  }

  function smoothScrollTo(target, root) {
    if (!target) return;

    var offset = getFocusableHeaderOffset(root);
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  function initSmoothScroll(root) {
    root.querySelectorAll('[data-aq-scroll]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        var target = root.querySelector(href);
        if (!target) return;

        event.preventDefault();
        smoothScrollTo(target, root);
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  function getTrackingValue(key) {
    if (key === 'landing_page_url') return window.location.href;
    if (key === 'referrer_url') return document.referrer || '';

    var params = new URLSearchParams(window.location.search);
    return params.get(key) || '';
  }

  function initTrackingFields(root) {
    root.querySelectorAll('.js-aq-tracking').forEach(function (field) {
      var key = field.getAttribute('data-aq-tracking');
      field.value = getTrackingValue(key);
    });

    TRACKING_KEYS.forEach(function (key) {
      var value = getTrackingValue(key);
      if (value) {
        try {
          window.sessionStorage.setItem('aq_' + key, value);
        } catch (error) {
          return;
        }
      }
    });

    root.querySelectorAll('.js-aq-tracking').forEach(function (field) {
      var key = field.getAttribute('data-aq-tracking');
      if (!TRACKING_KEYS.includes(key) || field.value) return;

      try {
        field.value = window.sessionStorage.getItem('aq_' + key) || '';
      } catch (error) {
        field.value = '';
      }
    });
  }

  function setFieldError(field, message) {
    var wrapper = field.closest('.aq-field');
    if (!wrapper) return;

    var error = wrapper.querySelector('.aq-field-error');
    wrapper.classList.toggle('is-invalid', Boolean(message));
    field.setAttribute('aria-invalid', message ? 'true' : 'false');

    if (error) {
      var errorId = error.id || field.id + '-error';
      error.id = errorId;
      error.textContent = message || '';
      field.setAttribute('aria-describedby', errorId);
    }
  }

  function validateField(field) {
    var value = field.value.trim();

    if (field.hasAttribute('required') && !value) {
      return field.tagName === 'SELECT' ? 'Please select an option.' : 'This field is required.';
    }

    if (field.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return 'Please enter a valid work email.';
    }

    if (field.type === 'tel' && value && value.replace(/[^\d]/g, '').length < 8) {
      return 'Please enter a valid mobile number.';
    }

    return '';
  }

  function initForms(root) {
    root.querySelectorAll('.js-aq-form').forEach(function (form) {
      var fields = form.querySelectorAll('input:not([type="hidden"]), select, textarea');

      fields.forEach(function (field) {
        field.addEventListener('blur', function () {
          setFieldError(field, validateField(field));
        });

        field.addEventListener('input', function () {
          if (field.getAttribute('aria-invalid') === 'true') {
            setFieldError(field, validateField(field));
          }
        });
      });

      form.addEventListener('submit', function (event) {
        var firstInvalid = null;

        fields.forEach(function (field) {
          var message = validateField(field);
          setFieldError(field, message);

          if (message && !firstInvalid) {
            firstInvalid = field;
          }
        });

        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.focus();
        }
      });
    });
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-aq-accordion]').forEach(function (accordion) {
      accordion.querySelectorAll('.aq-accordion__button').forEach(function (button) {
        button.addEventListener('click', function () {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          var panel = document.getElementById(button.getAttribute('aria-controls'));
          button.setAttribute('aria-expanded', String(!expanded));

          if (panel) {
            panel.hidden = expanded;
          }
        });
      });
    });
  }

  function initMarquee(root) {
    root.querySelectorAll('[data-aq-marquee]').forEach(function (marquee) {
      var track = marquee.querySelector('.aq-marquee__track');
      if (!track || track.getAttribute('data-aq-duplicated') === 'true') return;

      var items = Array.prototype.slice.call(track.children);
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      track.setAttribute('data-aq-duplicated', 'true');
    });
  }

  function initReveals(root) {
    root.classList.add('aq-js');

    var items = root.querySelectorAll('.aq-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initSuccessFocus(root) {
    var success = root.querySelector('.aq-form-success');
    if (success) {
      success.focus({ preventScroll: true });
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-aq-initialized') === 'true') return;

    root.setAttribute('data-aq-initialized', 'true');
    initSmoothScroll(root);
    initTrackingFields(root);
    initForms(root);
    initAccordions(root);
    initMarquee(root);
    initReveals(root);
    initSuccessFocus(root);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.matches && event.target.matches(SELECTOR)
      ? event.target
      : event.target.querySelector(SELECTOR);
    init(root);
  });
})();
